module.exports = __webpack_public_path__ + "img/greenwich-g-series-rectangle-side-angle.82c682e1.png";